<script>

import { Overlay } from '../../'

export default {
    name: 'MassIndex',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Mass Index - Identifies trend reversals based on range expansion',
                preset: {
                    name: 'Mass Index $ema_length $sum_length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#9c27b0',
                        threshold: 27
                    }
                }
            }
        },
        use_for() { return ['MassIndex'] },
        calc() {
            return {
                props: {
                    ema_length: { def: 9, text: 'EMA Length' },
                    sum_length: { def: 25, text: 'Sum Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let spread = ts(high[0] - low[0])
                    let first = ema(spread, ema_length)
                    let second = ema(first, ema_length)
                    let ratio = ts(second[0] ? first[0] / second[0] : NaN)
                    return sum(ratio, sum_length)[0]
                `
            }
        }
    }
}
</script>
